/**
 * 深度展平阵列
 * @param {*} arr
 * deepFlatten([1, [2], [[3], 4], 5]); // [1,2,3,4,5]
 */
export const deepFlatten = arr =>
  [].concat(...arr.map(v => (Array.isArray(v) ? deepFlatten(v) : v)));

/**
 * 数组去重
 */
export const arrayUnique = arr => {
  if (!Array.isArray(arr)) throw Error('type error，入参需为数组类型');
  let array = [arr[0]];
  arr.map(item => {
    if (array[0] !== item) array.push(item);
  });
  return array;
};